var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9702 12.192L21.6532 21.049L12.0052 22.474C11.6127 22.5367 11.2453 22.707 10.9439 22.966C10.6424 23.225 10.4187 23.5626 10.2976 23.9411C10.1764 24.3196 10.1626 24.7243 10.2577 25.1102C10.3528 25.4961 10.553 25.8481 10.8362 26.127L17.8192 33.018L16.1672 42.752C16.0964 43.1421 16.1366 43.5442 16.2832 43.9127C16.4297 44.2811 16.6767 44.6009 16.996 44.8359C17.3154 45.0709 17.6943 45.2114 18.0896 45.2417C18.4849 45.2719 18.8808 45.1906 19.2322 45.007L27.8662 40.407L36.5002 45.007C36.8516 45.1898 37.2473 45.2705 37.6423 45.2399C38.0372 45.2093 38.4157 45.0686 38.7348 44.8338C39.0539 44.5991 39.3008 44.2796 39.4476 43.9116C39.5944 43.5437 39.6351 43.1419 39.5652 42.752L37.9132 33.018L44.8962 26.127C45.1793 25.8481 45.3796 25.4961 45.4746 25.1102C45.5697 24.7243 45.5559 24.3196 45.4348 23.9411C45.3137 23.5626 45.0899 23.225 44.7885 22.966C44.487 22.707 44.1196 22.5367 43.7272 22.474L34.0752 21.049L29.7622 12.192C29.5916 11.8337 29.3229 11.5311 28.9873 11.3192C28.6518 11.1073 28.263 10.9949 27.8662 10.9949C27.4693 10.9949 27.0806 11.1073 26.745 11.3192C26.4095 11.5311 26.1408 11.8337 25.9702 12.192Z",
    fill: "#FFA200",
    stroke: "#CB8100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarbg);
export default __webpack_public_path__ + "static/media/starbg.5cb1d7ff5f74794df337e3ed9f9a4617.svg";
export { ForwardRef as ReactComponent };